/*@flow*/
/** @jsx jsx */
// @ts-check
import { jsx, css } from '@emotion/core';
import { useEffect } from 'react';
import waitTill from 'lib/waitTill';
import useStoreState from 'lib/useStoreState';
import getQueryKey from 'lib/getQueryKey';
import PATHS from 'const/paths';
import isSmallScreen from 'lib/isSmallScreen';
import Blank from 'lib/Blank';
import truthy from 'lib/truthy';

export function useHide() {
  const { areaId, hideRightSidebar } = useStoreState({
    hideRightSidebar: PATHS.hideRightSidebar,
    areaId: () => getQueryKey('area_id', null),
  });
  const isToggledOpen = Blank.is(areaId) ? truthy(hideRightSidebar) : false;
  return isSmallScreen() || isToggledOpen;
}
